import React, { useEffect, useState } from "react";
import "./balance.style.scss";
import { get, responseValidator, SITEURL } from "../../../api";
import { Button, Card } from "antd";
import Loading from "../../../loading/loading.index";
import { toast } from "react-toastify";
import { ToIranCurrency } from '../../../util/string'
export default function Balance() {
    const [data, setData] = useState(null);

    function onRefreshHandler() {
        setData(null);
        get("/Market/Balances").then(res => {
            if (responseValidator(res.status)) setData(res.data.data);
            else {
                toast.error(res.data.message);
            }
        });
    }

    useEffect(() => {
        get("/Market/Balances").then(res => {
            if (responseValidator(res.status)) setData(res.data.data);
            else {
                toast.error(res.data.message);
            }
        });
    }, []);

    if (!data) return <Loading />;

    return (
        <div className="temx-admin-balance-page">
            <Card
                title={
                    <div className="complete-tickets">
                        <h4>موجودی حساب</h4>
                        <span />
                        <button
                            onClick={onRefreshHandler}
                            className="ant-btn ant-btn-ghost"
                        >
                            {" "}
                            بازیابی
                        </button>
                    </div>
                }
            >
                <div className="items">
                    <img src={SITEURL + "media/icons/usdt.svg"} alt="usdt" />
                    <h4> تتر :</h4>
                    <p>{data.tetherBalance} واحد</p>
                </div>
                <div className="items">
                    <img src={SITEURL + "media/icons/pm.svg"} alt="pm" />
                    <h4> تتر :</h4>
                    <p>{data.perfectMoneyBalance} واحد</p>
                </div>
                <div className="items">
                    <img
                        src={SITEURL + "media/icons/webmoney.svg"}
                        alt="webmoney"
                    />
                    <h4> وب مانی :</h4>
                    <p>{data.webmoneyBalance} واحد</p>
                </div>
                <div className="items">
                    <img src={SITEURL + "media/icons/irt.svg"} alt="irt" />
                    <h4>جیبیمو  :</h4>
                    <p>{ToIranCurrency((parseFloat(data.irtBalanceJibimo)/10))} تومان</p>
                </div>
                <div className="items">
                    <img src={SITEURL + "media/icons/irt.svg"} alt="irt" />
                    <h4>وندار  :</h4>
                    <p>{ToIranCurrency(data.irtBalanceVandar)} تومان</p>
                </div>
                <div className="items">
                    <img src={SITEURL + "media/icons/irt.svg"} alt="irt" />
                    <h4>جیبیت  :</h4>
                    <p>{ToIranCurrency(data.irtBalanceJibit)} تومان</p>
                </div>
            </Card>
        </div>
    );
}
